import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import SideBar from "../../../components/SideBar";
import { Dashboard } from "./Dashboard";
import { getAchievementInteractionVideos, openInteractionVideo } from "../../../api/VideoInteractions/videoInteractions";
import { ToastContainer, toast } from "react-toastify";
import VideoPreviewModal from "./VideoPreviewModal/VideoPreviewModal";
import HamVideoPlayer from "./HamVideoPlayer";
import BackButton from "../../../components/Base/BackButton";

const style = {
  container: {
    padding: "24px"
  }
};

export default function VideosListPage() {

  const history = useHistory();
  const location = useLocation();

  const { user, selectedCourse } = location.state || {};

  const [videoRecords, setVideoRecords] = useState([]);
  const [videoStats, setVideoStats] = useState([]);
  const [isLoadingVideos, setIsLoadingVideos] = useState(false);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [hamVideo, setHamVideo] = useState(null);

  const loadCourseVideos = async (course) => {

    try {

      setIsLoadingVideos(true);

      const payload = {
        SegmentCourseId: course.Id
      };

      const res = await getAchievementInteractionVideos(
        user.Token,
        payload
      );

      if (res.data.ResponseStatus === 1) {

        const response = res.data.ResponseData;

        const details = response?.Details || [];
        const stats = response?.Counts || [];
        setVideoStats(stats);

        const mapped = details.map((item) => ({
          id: item.AchievementVideoId,
          AchievementId: item.AchievementId,
          title: item.AchievementVideoTitle,
          status: item.VideoInteractionStatus,
          videoStatus: item.VideoStatus ?? null,
          createdDate:item.CreatedDate,
          updatedAt: item.ModifiedDate,
          ownerName: `${item.Teacher?.Name ?? ""} ${item.Teacher?.Surname ?? ""}`,
          lesson: course.Name
        }));

        setVideoRecords(mapped);

      } else {
        toast.error("Video listesi alınamadı.");
      }

    } catch (err) {

      console.error(err);
      toast.error("Video listesi alınırken hata oluştu.");

    } finally {

      setIsLoadingVideos(false);

    }

  };

  useEffect(() => {

    if (!selectedCourse || !user) return;

    loadCourseVideos(selectedCourse);

  }, [selectedCourse, user]);


//   const handleEditVideo = (videoId) => {

//     const video = videoRecords.find((v) => v.id === videoId);

//     history.push({
//       pathname: "/VideoInteraction",
//       state: {
//         builderData: video,
//         user,
//         selectedCourse
//       }
//     });

//   };

  const handleEditVideo = async (achievementVideoId) => {
    try {
        setIsLoadingVideos(true);
        const payload = {
            AchievementVideoId:achievementVideoId
        }
      const res = await openInteractionVideo(
        user.Token,
        payload
      );
  
      if (res.data.ResponseStatus === 1) {
        const video = res.data.ResponseData;
  
        history.push({
          pathname: "/VideoInteraction",
          state: {
            builderData: video,
            selectedCourse
          },
        });
      } else {
        toast.error("Video bilgisi alınamadı.");
      }
    } catch (err) {
      toast.error("Video yüklenirken hata oluştu.");
    } finally {
        setIsLoadingVideos(false);
    }
  };


  const handleOpenVideo = async (achievementVideoId) => {
    console.log("handleOpenVideo",achievementVideoId);
    try {
        setIsLoadingVideos(true);
        const payload = {
            AchievementVideoId:achievementVideoId
        }
      const res = await openInteractionVideo(
        user.Token,
        payload
      );
  
      if (res.data.ResponseStatus === 1) {
        const video = res.data.ResponseData;
        console.log("videoURL",video);
        setPreviewVideo(video)
      
      } else {
        toast.error("Video bilgisi alınamadı.");
      }
    } catch (err) {
      toast.error("Video yüklenirken hata oluştu.");
    } finally {
        setIsLoadingVideos(false);
    }
  };

  const handleOpenHamVideo = async (achievementVideoId) => {
    try {
      setIsLoadingVideos(true);
      const res = await openInteractionVideo(user.Token, { AchievementVideoId: achievementVideoId });

      if (res.data.ResponseStatus === 1) {
        setHamVideo(res.data.ResponseData);
      } else {
        toast.error("Video bilgisi alınamadı.");
      }
    } catch {
      toast.error("Video yüklenirken hata oluştu.");
    } finally {
      setIsLoadingVideos(false);
    }
  };

  if (!selectedCourse) {

    return (
      <>
        <SideBar />
        <div style={style.container}>
        <BackButton />
          <p>Kurs seçilmedi.</p>
        </div>
      </>
    );

  }

  function resolveUserRole(role) {
    if (role === "Administrators" || role === "ContentManagers") return "superAdmin";
    return "teacher";
  }
  
  
  return (
    <>
      <SideBar />
      <ToastContainer />
      <div style={style.container}>
      <BackButton />
        <Dashboard
          users={[]}
          currentUser={{
            role: resolveUserRole(user.Role),
            id: user.Id,
            lesson: selectedCourse?.Name
          }}
          records={Array.isArray(videoRecords) ? videoRecords : []}
          stats={videoStats}
          isLoading={isLoadingVideos}
          onChangeUser={() => {}}
          onEdit={handleEditVideo}
          onOpenVideo={handleOpenVideo}
          onOpenHamVideo={handleOpenHamVideo}
        />
        <VideoPreviewModal
          open={Boolean(previewVideo)}
          video={previewVideo}
          onClose={() => setPreviewVideo(null)}
        />
        <HamVideoPlayer
          video={hamVideo}
          token={user.Token}
          userRole={resolveUserRole(user.Role)}
          onClose={() => {
            setHamVideo(null);
            loadCourseVideos(selectedCourse);
          }}
        />
      </div>
    </>
  );
}
